
Drupal.behaviors.popupStudents = {
  attach(context) {

    const popupStudents = new window.upceModal('students');

    if (popupStudents.status()) {

      // console.log("popup SB - students");

    }
  },
};
